export default function statusEnumToReadable(status: string): {
  label: string;
  color: string;
} {
  switch (status) {
    case 'ACTIVE':
      return {
        label: 'Active',
        color: 'green',
      };
    case 'UNDER_REVIEW':
      return {
        label: 'Under Review',
        color: 'amber',
      };
    case 'UNDER_OPS_REVIEW':
      return {
        label: 'Under Review',
        color: 'amber',
      };
    case 'INACTIVE':
      return {
        label: 'Inactive',
        color: 'gray',
      };
    case 'CANCELLED':
      return {
        label: 'Cancelled',
        color: 'stone',
      };
    case 'CLOSED':
      return {
        label: 'Closed',
        color: 'yellow',
      };
    case 'DELETED':
      return {
        label: 'Deleted',
        color: 'sky',
      };
    case 'CREATED':
      return {
        label: 'Created',
        color: 'indigo',
      };
    case 'COMPLETED':
      return {
        label: 'Completed',
        color: 'purple',
      };
    case 'DRAFT':
      return {
        label: 'Draft',
        color: 'gray',
      };
    case 'RAISING':
      return {
        label: 'Raising',
        color: 'green',
      };
    case 'COMMITTED':
      return {
        label: 'Committed',
        color: 'green',
      };
    case 'TRANSFERRED':
      return {
        label: 'Transferred',
        color: 'purple',
      };
    case 'WIRED':
      return {
        label: 'Wired',
        color: 'purple',
      };
    case 'EXECUTED':
      return {
        label: 'Executed',
        color: 'purple',
      };
    case 'FINALISED':
      return {
        label: 'Finalised',
        color: 'purple',
      };
    case 'POOLING':
      return {
        label: 'Pooling',
        color: 'purple',
      };
    case 'PUBLISHED':
      return {
        label: 'Published',
        color: 'green',
      };
    case 'EXITED':
      return {
        label: 'Exited',
        color: 'red',
      };
    case 'PARTIALLY_EXITED':
      return {
        label: 'Partially Exited',
        color: 'red',
      };
    case 'OPTED_IN':
      return {
        label: 'Opted In',
        color: 'green',
      };
    case 'OPTED_OUT':
      return {
        label: 'Opted Out',
        color: 'red',
      };
    case 'IN_PROCESS':
      return {
        label: 'In process',
        color: 'amber',
      };
    case 'CREDITED':
      return {
        label: 'Credited',
        color: 'green',
      };
    case 'IN_ESCROW':
      return {
        label: 'In Escrow',
        color: 'indigo',
      };
    case 'DEBITED':
      return {
        label: 'Debited',
        color: 'amber',
      };
    default:
      return {
        label: status,
        color: 'gray',
      };
  }
}
